import { useCallback, useEffect, useState, useRef } from 'react';
import { ROUTE_SECURITY_CONTACTS, ROUTE_SECURITY_CONTACTS_ADD, ROUTE_WELCOME } from '../../routes/Routes';
import { useNavigate } from "react-router-dom";
import usePageTitle from '../../hooks/usePageTitle';
import GetFetch from '../../hooks/GetFetch';
import { LoadingPanel } from "../../components/LoadingPanel";
import GetFetchZip from '../../hooks/GetFetchZip';
import { Button, SelectBox } from "devextreme-react";
import DataGrid, {
    Column,
    Format,
    Item,
    KeyboardNavigation,
    Pager,
    Paging,
    SearchPanel,
    Grouping,
    Toolbar
} from 'devextreme-react/data-grid';
import CustomPreparedHeaderCell from '../../components/CustomPreparedHeaderCell';
import { allowedPageSizes, pageFormats } from '../../components/GlobalDataGridConfigurations';
import { logExport, useAuth } from '../../hooks/useAuth';
import ExportGrid from '../../components/ExportGrid';
import '../BasicSecurityInformation/ListInformation.scss';


const BasicSecurityContacts = () => {
    const { title } = ROUTE_SECURITY_CONTACTS;
    const { user } = useAuth();
    const email = user.email.toString().toLowerCase();
    const navigate = useNavigate();
    const navigateToHomePage = () => navigate(ROUTE_WELCOME.withSlash);
    const dataGridRef = useRef(null);
    const [allowCreate, setAllowCreate] = useState(true);
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [dataSource, setDataSource] = useState([]);
    
    useEffect(() => { 
        getBasicSecurityContacts(); 
    }, []);
    usePageTitle( title );

    const getBasicSecurityContacts = async () => {
        setLoading(true);
        try {
            const { Success, Message, Errors } = await GetFetch(`/v1/BasicSecurity/Contacts`);
            if (Success)
                setDataSource(Message.map(item => item));

            if (Errors.length > 0)
                console.error(Errors);
        } 
        catch (error) 
        {
            console.error('Error: ', error);
        }
        setLoading(false);
    };

    const fetchBasicSecurityDocuments = async () => {
        setLoading(true);
        const data = await GetFetch(`/v1/BasicSecurity/Contacts`);
        const { Success, Message, Errors } = data;
        setError(Success === false);
        
        if (Success) {
            setDataSource(Message);
        }
        if (Errors?.length > 0) {
            setErrorMessage(Errors[0].Message)
            console.log(Errors)
        }
        setLoading(false);
    };
    
    const GroupCell = options => <div>{options.caption}</div>;
    const onBackClick = () => {
        navigateToHomePage();
    };

    const handleExport = (e) => {
        logExport(user.email)
        ExportGrid(e, title, true, 12)
    };

    const combinedOnCellPrepared = (e) => {
        CustomPreparedHeaderCell(e);
    
        if (e.rowType === 'group') {
            const groupName = `Agency ${e.data?.key}`;
    
            const isCollapsed = e.cellElement.querySelector('.dx-datagrid-group-closed');
            const ariaLabel = isCollapsed ? `Expand ${groupName}` : `Collapse ${group-Name}`;
            const ariaExpanded = isCollapsed ? 'false' : 'true';
    
            e.cellElement.setAttribute('aria-label', ariaLabel);
            e.cellElement.setAttribute('aria-expanded', ariaExpanded);
        }
    };

    return (
        <>
            <div className="inline__div--wrapper">
                <h1> { title } </h1>
            </div>
            {allowCreate &&
                <Button
                    stylingMode="contained"
                    text="Add Basic Security Contacts"
                    width={275}
                    onClick={() => navigate(ROUTE_SECURITY_CONTACTS_ADD.withSlash)}
                    id="add_basic_security_contacts"
                />
            }
            {loading && <LoadingPanel location={{ of: '#bsa-docs' }} message="Loading Basic Security Contacts..." />}
            {
                !loading &&
                <div id='bsa-docs' className="inline__div--wrapper">
                    <DataGrid 
                        columnAutoWidth={true}
                        dataSource={dataSource}
                        ref={dataGridRef}
                        onCellPrepared={combinedOnCellPrepared}
                        onExporting={e => handleExport(e)}
                        rowAlternationEnabled={true}
                        showBorders={true}
                        showColumnLines={true}
                        showRowLines={true}
                        export={{enabled: true, formats: pageFormats}}
                        key="Id"
                        >
                        <Toolbar>
                            <Item
                                location="after"
                                name="searchPanel"
                                locateInMenu="auto"
                            />
                            <Item
                                location='after'
                                name="exportButton"
                                enabled={true}
                                formats={pageFormats}
                            />
                        </Toolbar>
                        <Column 
                            dataField="Id"
                            visible={false}
                            alignment='left'
                        />
                        <Column 
                            caption='AGBU'
                            dataField='AGBU'
                        />
                        <Column 
                            caption='Agency Name'
                            dataField='AgencyName'
                            groupIndex={0}
                        />                        
                        <Column 
                            caption='Bureau Name'
                            dataField='BureauName'
                        />                      
                        <Column 
                            caption='Main POC'
                            dataField='MainPOC'
                        />
                        <Column 
                            caption='POC Title'
                            dataField='POCTitle'
                        />                        
                        <Column 
                            caption='POC Email'
                            dataField='POCEmail'
                        />
                        {/* <Column
                            caption='Created By'
                            dataField='CreatedBy'
                        />
                        <Column
                            caption='Created Date'
                            dataField='CreatedDate'
                        />
                        <Column
                            caption='Updated By'
                            dataField='UpdatedBy'
                        />
                        <Column
                            caption='Updated Date'
                            dataField='UpdatedDate'
                        /> */}
                        <KeyboardNavigation enabled={true} />
                        <Grouping autoExpandAll={false} />                        
                        <SearchPanel 
                            highlightCaseSensitive={true}
                            visible={true}
                        />
                        <Pager 
                            allowedPageSizes={allowedPageSizes}
                            showPageSizeSelector={true}
                        />
                        <Paging 
                            defaultPageSize={10}
                        />
                    </DataGrid>
                </div>
            }
        </>
    )
};

export default BasicSecurityContacts;